import React from "react";
import { Smile } from "lucide-react";
import { Container, Row, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Utils } from "@/common/utils";

export const SuccessPage = () => {
    const navigate = useNavigate();

    const handleGoHome = () => {
        const url = Utils.getLinkBase();
        navigate(url + "/home");
    };

    const handleStartNewMatching = () => {
        const url = Utils.getLinkBase();
        navigate(url + "/competency-matching");
    };

    return (
        <Container className="success-page text-center py-5">
            <Row className="justify-content-center">
                <div className="success-content">
                    <div className="success-icon mb-4">
                        <Smile size={40} color="#fff" />
                    </div>
                    <h5 className="mb-3">Congratulations!</h5>
                    <h2 className="mb-4">You&apos;ve completed the matches!</h2>
                    <p className="mb-5">
                        You completed this category. Want to do another one?
                    </p>
                    <div className="d-flex justify-content-center gap-3">
                        <Button
                            variant="outline-secondary"
                            size="lg"
                            onClick={handleGoHome}
                        >
                            Go home
                        </Button>
                        <Button
                            variant="primary"
                            size="lg"
                            onClick={handleStartNewMatching}
                        >
                            Start new matching
                        </Button>
                    </div>
                </div>
            </Row>
        </Container>
    );
};